<template>
    <v-card>
        <v-card-title
            class="justify-center mt-1"
            style="
                font-size: 1.9em;
                font-weight: 400;
            "
        >
            Responder Solicitação
        </v-card-title>
        <v-alert
            :value="true"
            type="info"
            class="pa-2 ma-0"
            outline
            style="width: 100%; font-size: 1.1em;"
        >
            {{ solicitacao.descricao }}
        </v-alert>
        <v-card-text>
            <v-layout wrap justify-space-between v-if="solicitacao">
                <v-flex xs5 class="mb-3">
                  <b>Data de envio:</b> {{solicitacao.data | formatDate('DD/MM/YYYY') }}
                </v-flex>
                <v-flex xs5 class="mb-3">
                  <b>Data de encerramento:</b> {{solicitacao.data_encerramento ? (solicitacao.data_encerramento | formatDate('DD/MM/YYYY'))  : 'Não finalizada'}}
                </v-flex>
                <v-flex xs5 class="mb-3">
                  <b>Status:</b> {{returnStatus(solicitacao.status)}}
                </v-flex>
                <v-flex xs5 class="mb-3">
                  <b>Tipo:</b> {{solicitacao.tipo}}
                </v-flex>
                <v-flex xs12 class="mb-3">
                  <h3 style="text-align: center;">Responsável Pela Solicitação</h3>
                </v-flex>
                <template v-if="solicitacao_data.empresa">
                    <v-flex xs5 class="mb-3">
                        <b>Nome da Empresa:</b> {{ solicitacao_data.empresa.nome_fantasia }}
                    </v-flex>
                    <v-flex xs5 class="mb-3">
                        <b>CNPJ:</b> {{ formatarCnpj(solicitacao_data.empresa.cnpj) }}
                    </v-flex>
                    <v-flex xs5 class="mb-3">
                        <b>Tipo de Empresa Atual:</b> {{ tipos_empresa[solicitacao_data.empresa.tipo_empresa] }}
                    </v-flex>
                    <v-flex xs5 class="mb-3">
                        <b>Contato da Empresa:</b> {{ solicitacao_data.empresa.contato1 }}
                    </v-flex>
                    <v-flex xs12 class="mb-3">
                        <b>Razão Social:</b> {{ solicitacao_data.empresa.razao_social }}
                    </v-flex>
                </template>
                <template v-if="solicitacao_data.pessoa">
                    <v-flex xs5 class="mb-3">
                    <b>Nome do Responsável:</b> {{ solicitacao_data.pessoa.nome_completo }}
                    </v-flex>
                    <v-flex xs5 class="mb-3">
                    <b>Identificador:</b> {{ solicitacao_data.pessoa.id_pessoa }}
                    </v-flex>
                    <v-flex xs5 class="mb-3">
                    <b>CPF:</b> {{ formatarCpf(solicitacao_data.pessoa.cpf) }}
                    </v-flex>
                    <v-flex xs5 class="mb-3">
                    <b>E-mail:</b> {{ solicitacao_data.pessoa.email }}
                    </v-flex>
                    <v-flex xs5 class="mb-3">
                    <b>Telefone:</b> {{ formatarTelefone(solicitacao_data.pessoa.telefone) }}
                    </v-flex>
                </template>
            </v-layout>
        </v-card-text>
        <v-card-actions>
            <v-layout wrap justify-space-around class="mb-1">
                <v-flex xs5>
                    <v-btn
                        block
                        color="error"
                        flat
                        @click="responderSolicitacao(false)"
                    >
                        Rejeitar
                    </v-btn>
                </v-flex>
                <v-flex xs5>
                    <v-btn
                        block
                        color="success"
                        flat
                        @click="responderSolicitacao(true)"
                    >
                        Aceitar
                    </v-btn>
                </v-flex>
            </v-layout>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    props: ['solicitacao'],
    data: () => ({
        solicitacao_data: {
            posto: {},
            rede: {},
            empresa: {},
            pessoa: {}
        },
        tipos_empresa: [
            'Todos os Tipo',
            'Frota de Veículos',
            'Revendedora de Veículos',
            'Automação',
            'Venda de Produtos',
            'Prestação de Serviços',
            'Venda de Produtos e Serviços',
            'Instituição Beneficente',
            'Integradora'
        ]
    }),
    beforeMount () {
        if (this.solicitacao) {
            this.pegarDetalhesDaSolicitacao()
        }
    },
    methods: {
        pegarDetalhesDaSolicitacao () {
            this.$store.dispatch('solicitacao', {
                id: this.solicitacao.id,
                method: 'GET'
            }).then(json => {
                this.solicitacao_data = json
            })
        },
        returnStatus (status) {
            switch (status) {
                case true:
                    return 'Aceita'
                case false:
                    return 'Negada'
                default:
                    return 'Aguardando Resposta'
            }
        },
        formatarTelefone (telefone) {
            if (!telefone) return 'Indefinido'
            if (telefone.length < 8) return 'Indefinido'
            if (telefone.length === 8) return `${telefone.slice(0, 4)}-${telefone.slice(4, 8)}`
            if (telefone.length === 9) {
                if (telefone.search('-') === -1) return `${telefone[0]}${telefone.slice(1, 4)}-${telefone.slice(5, 9)}`
                return telefone
            }
            if (telefone.length === 10) return `+(${telefone.slice(0, 2)}) ${telefone.slice(2, 6)}-${telefone.slice(6, 10)}`

            if (telefone.length === 11) return `(${telefone.slice(0, 2)}) ${telefone[2]} ${telefone.slice(3, 7)}-${telefone.slice(7, 11)}`

            if (telefone.length === 14) return `${telefone.slice(0, 3)} (${telefone.slice(3, 5)}) ${telefone[5]} ${telefone.slice(6, 10)}-${telefone.slice(10, 14)}`

            return telefone
        },
        formatarCep (cep) {
            if (!cep) return 'Indefinido'
            if (cep.length < 8) return 'Indefinido'
            if (cep.length === 8) return `${cep.slice(0, 5)}-${cep.slice(5, 8)}`
            return cep
        },
        formatarCpf (cpf) {
            if (!cpf) return 'Indefinido'
            if (cpf.length < 11) return 'Indefinido'
            if (cpf.length === 11) return `${cpf.slice(0, 3)}.${cpf.slice(3, 6)}.${cpf.slice(6, 9)}.${cpf.slice(9, 11)}`
            return cpf
        },
        formatarCnpj (cnpj) {
            if (!cnpj) return 'Indefinido'
            if (cnpj.length < 14) return 'Indefinido'
            if (cnpj.length === 14) return `${cnpj.slice(0, 2)}.${cnpj.slice(2, 5)}.${cnpj.slice(5, 8)}/${cnpj.slice(8, 12)}-${cnpj.slice(12, 14)}`
            return cnpj
        },
        responderSolicitacao (resposta) {
            const data = {
                resposta: resposta,
                id: this.solicitacao.id,
                method: 'PUT'
            }
            this.$store.dispatch('solicitacao', data).then(() => {
                this.$emit('success', `Soliciatação ${ resposta ? 'aceita' : 'rejeitada' } com sucesso`)
                this.$emit('fechar')
            })
        }
    }
}
</script>
